module.exports = __webpack_public_path__ + "img/07.6a555cd9.png";